import React, { useState } from 'react';
import { reportsAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

function monthStartISO() {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10);
}

const todayISO = () => new Date().toISOString().slice(0, 10);
function weekStartISO() {
  const d = new Date();
  const day = (d.getDay() + 6) % 7; // Monday = 0
  d.setDate(d.getDate() - day);
  return d.toISOString().slice(0, 10);
}

/**
 * Timesheet download with a From/To reporting period. Pass `presets` to show
 * quick Today / This Week / This Month buttons (used on admin & HR dashboards).
 */
export default function TimesheetDownload({ presets = false }) {
  const { user } = useAuth();
  const [fromDate, setFromDate] = useState(monthStartISO());
  const [toDate, setToDate] = useState(todayISO());
  const [downloading, setDownloading] = useState(false);

  const runDownload = async (from, to, label) => {
    if (!user?.id) return;
    setDownloading(true);
    try {
      const { data } = await reportsAPI.downloadMonthly(user.id, {
        from_date: from, to_date: to, tz_offset: -new Date().getTimezoneOffset(),
      });
      const url = URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.href = url; a.download = `timesheet_${label || `${from}_to_${to}`}.csv`; a.click();
      URL.revokeObjectURL(url);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="card mb-6" style={{ padding: '16px 20px' }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 16, flexWrap: 'wrap' }}>
        <div>
          <strong>Timesheet Report</strong>
          <div className="text-muted" style={{ fontSize: 12 }}>
            Working hours (from tasks) &amp; office hours (attendance). Choose a period and download.
          </div>
        </div>
        <div className="form-group" style={{ margin: 0 }}>
          <label style={{ fontSize: 12 }}>From Date</label>
          <input type="date" value={fromDate} max={toDate} onChange={(e) => setFromDate(e.target.value)} />
        </div>
        <div className="form-group" style={{ margin: 0 }}>
          <label style={{ fontSize: 12 }}>To Date</label>
          <input type="date" value={toDate} min={fromDate} onChange={(e) => setToDate(e.target.value)} />
        </div>
        <button className="btn btn-primary" onClick={() => runDownload(fromDate, toDate)} disabled={downloading || !fromDate || !toDate}>
          {downloading ? 'Preparing…' : '⬇ Download Report'}
        </button>
      </div>

      {presets && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
          <span className="text-muted" style={{ fontSize: 12, alignSelf: 'center' }}>Quick:</span>
          <button className="btn btn-sm btn-ghost" disabled={downloading} onClick={() => runDownload(todayISO(), todayISO(), `daily_${todayISO()}`)}>Today (Daily)</button>
          <button className="btn btn-sm btn-ghost" disabled={downloading} onClick={() => runDownload(weekStartISO(), todayISO(), 'this_week')}>This Week</button>
          <button className="btn btn-sm btn-ghost" disabled={downloading} onClick={() => runDownload(monthStartISO(), todayISO(), 'this_month')}>This Month</button>
        </div>
      )}
    </div>
  );
}
